export const PLEASE_FILL_PASSWORD = "Please fill password";
export const PLEASE_FILL_USERNAME = "Please fill username";
export const USER_SESSION_EXPIRED = "Your session has expired. Please login again.";
export const ssoLoginFailed =
  "Failed to log in to the Twiage system. This may be because:\n" +
  "1. The user does not have a Twiage account.\n" +
  "2. Your organization's identity provider is not configured properly with Twiage.\n" +
  "Please contact your IT department to confirm the account configuration.";
export const ssoTokenMissingExpiration = "Single Sign-On token is missing an expiration date.";
